import {IconButton} from '@dropbox/dig-components/buttons';
import {UIIcon} from '@dropbox/dig-icons';
import {SliderLine} from '@dropbox/dig-icons/assets';
import {useCallback, useState} from 'react';

import {HeadingSettingsPopover} from './HeadingSettingsPopover';
import {useIsTemplateMode} from './RoleContext';

interface HeadingSettingsButtonProps {
  headingId: string;
}

export const HeadingSettingsButton = ({headingId}: HeadingSettingsButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const isTemplateMode = useIsTemplateMode();

  const handleToggleSettings = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  // Only show settings button in template mode
  if (!isTemplateMode) {
    return null;
  }

  return (
    <span>
      <IconButton variant="opacity" onClick={handleToggleSettings}>
        <UIIcon src={SliderLine} size="small" color="subtle" />
      </IconButton>
      {isOpen && <HeadingSettingsPopover headingId={headingId} onClose={() => setIsOpen(false)} />}
    </span>
  );
};
